<template>
  <div class="agreement-dialog" :style="show ? 'display:block' : 'display:none'">
    <div class="agreement-content">
      <!-- header -->
      <section class="dialog-header">
        <div>{{matchName}}参赛声明</div>
      </section>
      <!-- content -->
      <section class="dialog-body">
        <div class="game-detail-text">
          <p>
            请所有参赛选手报名之前务必认真、仔细阅读《{{matchName}}参赛声明》，在您提交报名信息后即被默认为您已阅读、理解并同意遵守《{{matchName}}报名须知》及《{{matchName}}赛竞赛规程》的一切内容。
          </p>
          <h4 class="mb20">（一）参赛选手声明</h4>
          <div class="gama-conent-desc">
            <p>
              作为参赛选手，我本人、我的监护人、管理人、法定代理人以及任何可能代表我提起赔偿请求或诉讼的人做出以下声明：
            </p>
            <p>
              1、本人自愿参加本次赛事及赛事相关的一切活动，我确认本人具有参加本赛事相应的民事行为能力和民事责任能力,并且已获得监护人的同意；
            </p>
            <p>
              2、本人确认全面理解并同意遵守赛事组委会及协办机构所制定的各项规程、规则、规定、要求及采取的措施；
            </p>
            <p>
              3、本人必须提供真实有效的个人信息，代替他人报名须对报名选手的个人信息负责，并确保报名选手本人知悉本免责声明各项条款；
            </p>
            <p>
              4、本人承诺以本人名义参赛，知悉获得的参赛资格及号码布和计时芯片在内的竞赛物品不以任何方式转让给他人；
            </p>
            <p>5、本人承诺在比赛过程中服从裁判和赛事工作人员的管理和指挥；</p>
            <p>
              6、本人知悉参加此项比赛对健康状况有特殊要求以及存在的不安全因素，同时对参赛可能存在的各种风险和意外已做出审慎的评估，这些风险包括但不限于：交通事故；天气改变或自然灾害等引发的风险；湿热带来的危险，包括中暑等；自身身体状况，或伴随着活动本身的生理反应可能引发的风险；动物或昆虫可能对人体造成的侵害；其他可能面临的危险或意外和事故等。本人愿意承担比赛期间发生的自身意外风险责任，且同意组办方对于非组委会原因造成的伤害、死亡或其他任何形式的损失不承担任何形式的赔偿；
            </p>
            <p>
              7、本人已为参赛做好充分训练和准备并经国家认证的医疗机构体检，确认自身身体和精神健康状况符合参赛的各项要求；
            </p>
            <p>
              8、本人同意接受组委会在比赛期间本人发生意外情况下提供的现场急救性质的医务治疗，发生的一切医疗费用或住院费用等超出赛事保险赔付标准部分均由本人承担；
            </p>
            <p>
              9、本人同意在活动中若本人丧失意识，组委会的急救志愿者可采取一切手段进行急救，包括但不限于CPR心肺复苏，AED体外除颤，租用车辆或航空器进行快速转运。由此产生的法律责任以及伴随的费用，均由参赛选手承担，概不追究组办方和参与施救的急救志愿者任何法律和经济方面的责任；
            </p>
            <p>
              10、本人同意在活动中若发生任何风险，包括但不限于伤痛、身体损害、不可逆转的永久性身体损伤、后遗症、意外、责任以及事件伴随的经济损失，均由本人自己承担，与组委会无关；
            </p>
            <p>
              11、本人同意如因隐瞒身体健康情况，在比赛期间发生的人身伤害、局部或永久性伤残、死亡、医疗或住院费用，由本人承担全部责任或费用，免除赛事组委会全部责任，组办方对此不承担任何形式的赔偿；
            </p>
            <p>
              12、本人同意参加比赛有关的所有照片、图片、影片、录像片和影音片，永远归比赛组织单位所有，并同意赛事组委会或指定媒体及赞助商无偿使用或授权使用前述资料；
            </p>
            <p>
              13、本人承诺永久授权赛事组委会及其继承或受让单位使用本人于比赛的除证件号码和联系方式以外的个人信息、肖像、声音和外貌，其使用包括并不限于任何市场活动、任何商业用途、任何媒体、任何成品及其相关广告品；
            </p>
            <p></p>
            <p>14、本人愿意接收赛事组委会（包括赞助商）发布的相关赛事信息；</p>
            <p>
              15、本人同意通过赛事组委会官方网站自助打印获取马拉松完赛成绩证书；
            </p>
            <p>
              16、本人同意赛事组委会以我为被保险人投保人身意外险（含猝死）；
            </p>
          </div>

          <h4 class="mb20">（二） 参赛者身体状况要求</h4>
          <div class="gama-conent-desc">
            <p>
              马拉松是一项不断挑战自身极限，具有一定风险的运动项目。如果运动不当，可能造成不同程度的身体损伤，甚至危及生命。因此，路跑赛事参赛者应身体健康，而且要有经常参加跑步锻炼或训练的基础。参赛者应在有资质的正规医疗机构进行体检，并结合体检报告评估自己的身体状况，确认是否可以参加路跑运动比赛及活动。
              以下疾病或状况者不宜参加比赛：
            </p>
            <p>1、先天性心脏病或风湿性心脏病患者；</p>
            <p>2、高血压或脑血管疾病患者；</p>
            <p>3、心肌炎或其他心脏病患者；</p>
            <p>4、冠状动脉病患者或严重心律不齐者；</p>
            <p>5、血糖过高或过低的糖尿病患者；</p>
            <p>6、比赛日前两周以内患过感冒者；</p>
            <p>7、赛前一晚大量饮用烈性酒或睡眠不足者；</p>
            <p>8、孕妇；</p>
            <p>9、患有感染性疾病未痊愈者；</p>
            <p>10、其他不适合运动的疾病。</p>
            <p>
              参加路跑比赛的跑者应根据自身状况、训练时间长短、训练负荷的适应程度以及个人健康状况选择适宜的参赛项目。
              在比赛中，因个人身体及其他个人原因导致的人身损害和财产损失，由参赛选手个人承担责任。组委会要求所有参赛选手通过正规医疗机构进行体检(含心电图、心肌酶四项检查)，并结合体检报告进行自我评估，确认自己的身体状况能够适应长跑运动，才可报名参赛。
            </p>
          </div>

          <h4 class="mb20">（三）组委会取消参赛资格或比赛成绩的行为范畴</h4>
          <div class="gama-conent-desc">
            <p>
              组委会将对起点、全程路线和终点进行录像监控，在比赛期间出现下列问题之一，由组委会视情节轻重分别给予参赛选手取消比赛资格及成绩、禁赛1-2年及终身禁赛等处罚，并报请中国田径协会予以追加处罚：
            </p>
            <p>1、虚假年龄报名或报名后由他人替跑；</p>
            <p>
              2、参赛者携带他人计时芯片或一名选手同时携带两枚或两枚以上(包括男选手携带女选手)计时芯片参加比赛；
            </p>
            <p>3、不按规定的起跑顺序在非指定区域起跑；</p>
            <p>4、起跑有违反规则行为；</p>
            <p>5、关门时间到后不停止比赛或退出比赛后又返回赛道；</p>
            <p>
              6、没有沿规定线路跑完所报项目的全程，抄近道或乘交通工具途中插入；
            </p>
            <p>7、以接力方式完成比赛；</p>
            <p>
              8、不按规定要求重复通过终点、未跑完全程私自通过终点领取完赛纪念品；
            </p>
            <p>
              9、私自伪造号码布，使用其他赛事马拉松号码布，或未佩戴本次比赛号码布和计时芯片通过终点领取完赛纪念品；
            </p>
            <p>10、私自涂改、遮挡号码布参赛或转让号码布；</p>
            <p>
              11、出现不文明行为，不服从赛事工作人员的指挥，干扰赛事，打架斗殴，聚众闹事；
            </p>
            <p>12、其他违反规则规定的行为。</p>
            <p>
              利用虚假信息获取参赛资格或者报名后转让参赛资格给他人替跑者，报名者和替跑者皆属违规，比赛发生的一切后果责任自负。
            </p>
          </div>

          <h4 class="mb20">（四）其他说明：</h4>
          <div class="gama-conent-desc">
            <p>
              组委会将对起点、全程路线和终点进行录像监控，在比赛期间出现下列问题之一，由组委会视情节轻重分别给予参赛选手取消比赛资格及成绩、禁赛1-2年及终身禁赛等处罚，并报请中国田径协会予以追加处罚：
            </p>

            <p>1、关于“阳康”后参赛选手的建议：</p>
            <p>
              1）关于“阳康”的定义：身体没有明显的如发热、咳嗽、浑身酸痛等症状，且连续两天核酸检测为阴性。
            </p>
            <p>
              2）“阳康”后仍伴有明显的胸闷、气短及明显的体能下降者不建议参赛；
            </p>
            <p>
              3）在感染新冠病毒期间被临床医生明确诊断为“白肺”、“心包炎”、“心肌炎”、“心梗”等高风险并发症选手不建议参赛。
            </p>
            <p>
              4）“阳康”两个月后心电图仍显示具有潜在风险的心律失常（如频发性、多源性室性早搏、R-on-T室性早搏等）不建议参赛。
            </p>
            <p>
              5）“阳康”两个月后心脏彩色B超仍显示有明显的心功能下降及心脏结构变化的选手不建议参赛。
            </p>
            <p>
              2、所有参赛选手的信息和参赛资格必须通过相应权威部门审核，审核不通过的视为不具备报名资格，组委会將在第一时间退还报名费。
            </p>
            <p>3、如遇不可抗力，导致赛事改期或取消，组委会将另行通知。</p>
            <p>
              4、如因隐瞒或虚假填报信息而造成不良影响的，主办方有权取消其参赛资格，并依法追究相关法律责任。
            </p>
            <p>
              5、组委会将根据国家疫情防控形势和要求，实时更新本次赛事的参赛资格、参赛要求、赛事举办时间、赛事规模等，参赛选手须及时关注。
            </p>
            <p>
              本人已认真阅读并全面理解本参赛声明内容，且对上述所有内容予以确认并承担相应的法律责任。
            </p>
          </div>
        </div>
        <!-- </div>   -->
      </section>
      <!-- footer -->
      <section class="dialog-footer">
        <van-button type="danger" block @click="onAgree">我同意参赛协议并报名</van-button>
      </section>
    </div>
  </div>
</template>
<script>
  import { Button } from "vant";
  import { getQueryString } from "@/util/fn.js";

  export default {
    name: "Agreement",
    props: {
      show: Boolean,
    },
    components: {
      [Button.name]: Button,
    },
    data() {
      return {
        matchName: 111,
      };
    },
    mounted() {
      this.matchName = getQueryString('matchName');
    },
    methods: {
      // onClose(){
      //     this.isShow = false;
      // },
      onAgree() {
        // this.isShow = false;
        this.$emit("onAgree", { agree: true });
      },
    },
  };
</script>
<style lang="less">
  .agreement-dialog {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    overflow: hidden;
    z-index: 100;
    background-color: rgba(0, 0, 0, 0.7);
  }

  .agreement-content {
    display: flex;
    flex-direction: column;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0px;
    overflow: hidden;
    z-index: 101;
    background-color: #fff;
  }

  .dialog-header {
    position: relative;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    border-bottom: 1px solid #efefef;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .dialog-close {
    position: absolute;
    width: 30px;
    height: 30px;
    top: 10px;
    right: 10px;
    line-height: 30px;
  }

  .dialog-body {
    flex: 1;
    overflow: hidden;
    padding: 0 10px;
  }

  .dialog-footer {
    height: 50px;
    padding: 0 20px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top: 1px solid #efefef;
  }

  .dialog-footer .van-button {
    height: 35px;
  }

  .game-detail-text {
    color: #666;
    font-size: 12px;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    webkit-overflow-scrolling: touch;
  }

  .conMenu {
    background: #e50021;
    font-size: 20px;
    float: left;
    width: 100%;
    margin-bottom: 30px;
  }

  .menuListRight {
    width: 100%;
    float: left;
    padding-bottom: 50px;
  }

  .menuListRight li a {
    color: #fff;
    float: left;
    width: 100%;
    text-decoration: none;
    font-size: 16px;
    padding: 20px 35px;
    border-bottom: 1px solid #c80a23;
  }

  .menuListRight li a:hover {
    background: #c80a23;
  }

  .menuListRight .active a {
    background: #c80a23;
  }

  .conMenu .cnDesc {
    font-size: 32px;
    font-weight: 300;
    padding: 20px 20px 10px 30px;
    color: #fff;
  }

  .conMenu .enDesc {
    font-size: 14px;
    font-weight: normal;
    padding: 0 30px;
    margin-bottom: 20px;
    color: #fff;
  }

  .conMenu .line {
    border-top: 2px solid #fff;
    width: 20px;
    height: 0;
    display: inline-block;
    margin-left: 35px;
    margin-bottom: 40px;
  }

  .mb20 {
    margin-bottom: 20px;
  }

  .gama-conent-desc {
    padding-left: 15px;
  }
</style>